import { TagKey } from "@cof/tag-catalog-featureddealer-mfe";
import { stratumService } from "./stratum.service";
import { formatCampaignMonth } from "@/utils/parsedata.utils";

// Campaign Month Selection
export const publishCampaignSelectionScreenView = (): void => {
  stratumService.publish(TagKey.CAMPAIGN_MONTH_SELECTION_SCREEN_VIEW);
};

export const publishCampaignTileClick = (month: string, year: string): void => {
  const campaignMonth = formatCampaignMonth(month, year);
  stratumService.publish(TagKey.CAMPAIGN_MONTH_SELECTION_CHOICE_BUTTON_CLICK, {
    replacements: { value: JSON.stringify({ campaignMonth }) },
  });
};

export const publishCampaignSelectionBackClick = (): void => {
  stratumService.publish(TagKey.CAMPAIGN_MONTH_SELECTION_BACK_BUTTON_CLICK);
};

export const publishCampaignSelectionContinueClick = (): void => {
  stratumService.publish(TagKey.CAMPAIGN_MONTH_SELECTION_CONTINUE_BUTTON_CLICK);
};

// Final Review
export const publishFinalReviewScreenView = (): void => {
  stratumService.publish(TagKey.FINAL_REVIEW_SCREEN_VIEW);
};

export const publishFinalReviewSubmitClick = (): void => {
  stratumService.publish(TagKey.FINAL_REVIEW_SUBMIT_BUTTON_CLICK);
};

export const publishFinalReviewDoneClick = (): void => {
  stratumService.publish(TagKey.FINAL_REVIEW_MODAL_DONE_BUTTON_CLICK);
};

// Cancel Campaign
export const publishCancelCampaignScreenView = (): void => {
  stratumService.publish(TagKey.CANCEL_CAMPAIGN_DETAILS_SCREEN_VIEW);
};

export const publishCancelCampaignCancelClick = (): void => {
  stratumService.publish(TagKey.CANCEL_CAMPAIGN_CANCEL_BUTTON_CLICK);
};

export const publishCancelCampaignModalCancelClick = (): void => {
  stratumService.publish(TagKey.CANCEL_CAMPAIGN_MODAL_CANCEL_BUTTON_CLICK);
};

export const publishCancelCampaignModalKeepClick = (): void => {
  stratumService.publish(TagKey.CANCEL_CAMPAIGN_MODAL_KEEP_BUTTON_CLICK);
};

export const publishCancelCampaignBackClick = (): void => {
  stratumService.publish(TagKey.CANCEL_CAMPAIGN_BACK_BUTTON_CLICK);
};

// Global Error Modal
export const publishGlobalErrorModalView = (): void => {
  stratumService.publish(TagKey.GLOBAL_ERROR_MODAL_VIEW);
};

export const publishGlobalErrorRefreshClick = (): void => {
  stratumService.publish(TagKey.GLOBAL_ERROR_MODAL_REFRESH_BUTTON_CLICK);
};

export const publishGlobalErrorReturnClick = (): void => {
  stratumService.publish(TagKey.GLOBAL_ERROR_MODAL_RETURN_BUTTON_CLICK);
};

// Admin Eligibility Modal
export const publishAdminEligibilityModalView = (): void => {
  stratumService.publish(TagKey.ADMIN_ELIGIBILITY_MODAL_VIEW);
};

export const publishAdminEligibilityModalOkClick = (): void => {
  stratumService.publish(TagKey.ADMIN_ELIGIBILITY_MODAL_OK_BUTTON_CLICK);
};

// Product Eligibility Modal
export const publishProductEligibilityModalView = (): void => {
  stratumService.publish(TagKey.PRODUCT_ELIGIBILITY_MODAL_VIEW);
};

export const publishProductEligibilityContactClick = (): void => {
  stratumService.publish(TagKey.PRODUCT_ELIGIBILITY_MODAL_CONTACT_BUTTON_CLICK);
};

export const publishProductEligibilityReturnClick = (): void => {
  stratumService.publish(TagKey.PRODUCT_ELIGIBILITY_MODAL_RETURN_BUTTON_CLICK);
};

// Agreements Modal
export const publishAgreementsModalView = (): void => {
  stratumService.publish(TagKey.AGREEMENTS_MODAL_VIEW);
};

export const publishAgreementsNameInputChange = (): void => {
  // Do not send the raw name value — publish a zero-arg "field changed"
  // signal so customer PII never egresses to Stratum analytics (VULN-001).
  stratumService.publish(TagKey.AGREEMENTS_MODAL_NAME_INPUT_CHANGE);
};

export const publishAgreementsEmailInputChange = (): void => {
  // Do not send the raw email value — publish a zero-arg "field changed"
  // signal so customer PII never egresses to Stratum analytics (VULN-001).
  stratumService.publish(TagKey.AGREEMENTS_MODAL_EMAIL_INPUT_CHANGE);
};

export const publishAgreementsBackClick = (): void => {
  stratumService.publish(TagKey.AGREEMENTS_MODAL_BACK_BUTTON_CLICK);
};

export const publishAgreementsSendEmailClick = (): void => {
  stratumService.publish(TagKey.AGREEMENTS_MODAL_SEND_EMAIL_BUTTON_CLICK);
};

export const publishAgreementsTryAnotherEmailClick = (): void => {
  stratumService.publish(
    TagKey.AGREEMENTS_MODAL_TRY_ANOTHER_EMAIL_BUTTON_CLICK,
  );
};

export const publishAgreementsResendEmailClick = (): void => {
  stratumService.publish(TagKey.AGREEMENTS_MODAL_RESEND_EMAIL_BUTTON_CLICK);
};
